import styled from 'styled-components';
import { MIN_PANEL_WIDTH_PX, MAX_CHAT_WIDTH_PX } from './utils';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  // border: 2px dashed ${(props) => props.theme.colors.border || '#ccc'};
  padding: 16px;
  background: ${(props) => props.theme.colors.white};
  position: relative;
  min-height: 400px;
`;

export const SectionChatPanel = styled(Section)`
  background: radial-gradient(77.51% 157.3% at 18.46% 91.07%, #f6f9ff 0%, #ffffff 80.17%);
  padding: 8px 0px 24px 0px;
  flex: 1;
  min-width: 0;
`;

export const ChatAndDocumentWrap = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  width: 100%;
`;

export const ChatColumn = styled(SectionChatPanel)`
  overflow: hidden;
  flex: ${(props) => (props.$isDocumentOpen ? `0 0 ${props.$chatWidthPx}px` : '1')};
  min-width: ${(props) => (props.$isDocumentOpen ? `${MIN_PANEL_WIDTH_PX}px` : '0')};
  max-width: ${(props) => (props.$isDocumentOpen ? `${MAX_CHAT_WIDTH_PX}px` : 'none')};
  transition: ${(props) =>
    props.$isResizing ? 'none' : 'flex 0.15s ease, min-width 0.15s ease, max-width 0.15s ease'};
`;

const RESIZE_HANDLE_DEFAULT_COLOR = '#BABABA';
const RESIZE_HANDLE_HOVER_COLOR = '#5C5C5C';   
const RESIZE_HANDLE_ACTIVE_COLOR = '#2173FF';  

const getResizeHandleLineColor = (props) => {
  if (props.$isResizing) return RESIZE_HANDLE_ACTIVE_COLOR;
  if (props.$isHover) return RESIZE_HANDLE_HOVER_COLOR;
  return RESIZE_HANDLE_DEFAULT_COLOR;
};

export const ResizeHandle = styled.div`
  flex-shrink: 0;
  width: 8px;
  cursor: col-resize;
  user-select: none;
  position: relative;
  background: transparent;

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: ${(props) => (!props.$isHover && !props.$isResizing ? '0.5px' : '1px')};
    transform: translateX(-50%);
    background: ${(props) => getResizeHandleLineColor(props)};
    transition: width 0.1s ease, background 0.1s ease;
  }
`;

export const DocumentPanelSlot = styled.div`
  flex: ${(props) => (props.$isOpen ? '1' : '0 0 0')};
  min-width: ${(props) => (props.$isOpen ? `${MIN_PANEL_WIDTH_PX}px` : '0')};
  overflow: hidden;
  padding: 24px;
  transition: ${(props) =>
    props.$isResizing ? 'none' : 'flex 0.15s ease, min-width 0.15s ease'};
  background: ${(props) => props.theme.colors.white};
  /* No left border: ResizeHandle is the only divider line */
`;

export const SidebarSection = styled(Section)`
  flex: 0 0 ${(props) => (props.$isCollapsed ? '43.8px' : '244px')};
  max-width: ${(props) => (props.$isCollapsed ? '43.8px' : '244px')};
  border-top: none !important;
  border-bottom: none !important;
  border-left: none !important;
  border-right: 0.5px solid ${(props) => props.theme.colors.clearGray};
  transition: flex-basis 0.15s ease, max-width 0.15s ease;
  padding: 0px !important;
`;

export const SectionLabel = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  background: ${(props) => props.theme.colors.text || '#000'};
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;
